import { updateUsageDate, grid } from 'components/Presets/data/queryKeyFactory';
import { updateUsageDatePreset } from 'components/Presets/sources/presets';

import { useMutation, useQueryClient } from '@gogame/query';

export const useUpdateUsageDatePreset = ({ presetKey, orderBy }) => {
  const queryClient = useQueryClient();
  const updateMutation = useMutation(
    updateUsageDate(),
    ({ id }) => updateUsageDatePreset({ id }),
    {
      onMutate: async ({ id }) => {
        queryClient.setQueryData(
          grid({ presetKey, orderBy }),
          (previousPresets) => {
            if (Array.isArray(previousPresets)) {
              return [
                previousPresets.find((preset) => preset.id === id),
                ...previousPresets.filter((preset) => preset.id !== id),
              ];
            } else {
              return previousPresets;
            }
          }
        );
      },
    }
  );

  return [updateMutation.mutateAsync, updateMutation];
};
